export const fr = {
  common: {
    search: "Rechercher...",
    loading: "Chargement...",
    error: "Erreur",
    status: "Statut",
    priority: "Priorité",
    date: "Date",
    created: "Créé",
    user: "Utilisateur",
    actions: "Actions",
    cancel: "Annuler",
    save: "Enregistrer",
    submit: "Soumettre",
    submitting: "Envoi en cours...",
    edit: "Modifier",
    view: "Voir",
    delete: "Supprimer",
    loadingAnalysis: "Chargement de l'analyse...",
    title: "Titre"
  },
  sidebar: {
    dashboard: "Tableau de bord",
    submitIncident: "Signaler un incident",
    suggestions: "Suggestions",
    incidentLogs: "Journal des incidents",
    incidents: "Incidents",
    company: "Entreprise",
    companies: "Entreprises",
    users: "Utilisateurs",
    statistics: "Statistiques",
    myCompany: "Mon Entreprise"
  },
  dashboard: {
    title: "Tableau de bord",
    subtitle: "Aperçu des métriques d'incidents et activités récentes",
    reportNew: "Signaler un nouvel incident",
    viewLogs: "Voir tous les journaux",
    totalIncidents: "Total des incidents",
    pending: "En attente",
    pendingSubtext: "Ouvert & En cours",
    resolved: "Résolu",
    avgResolution: "Résolution moy.",
    commonCategory: "Catégorie fréquente",
    mostFrequent: "Type d'incident le plus fréquent",
    resolutionRate: "Taux de résolution",
    percentageResolved: "Pourcentage d'incidents résolus",
    recentIncidents: "Incidents récents",
    viewAll: "Voir tout",
    noIncidents: "Aucun incident trouvé."
  },
  incidentList: {
    title: "Journal des incidents",
    subtitle: "Voir et gérer tous les incidents signalés",
    searchPlaceholder: "Rechercher des incidents...",
    noIncidentsTitle: "Aucun incident trouvé",
    noIncidentsMsg: "Il n'y a aucun incident enregistré dans le système.",
    previous: "Précédent",
    next: "Suivant",
    page: "Page"
  },
  submitIncident: {
    title: "Créer un rapport d'incident",
    subtitle: "Fournissez des informations détaillées sur le problème technique rencontré",
    descriptionLabel: "Description de l'incident *",
    descriptionPlaceholder: "Décrivez l'incident en détail... Incluez ce qui s'est passé, quand cela a commencé, quels systèmes sont affectés et les messages d'erreur rencontrés.",
    priorityLabel: "Niveau de priorité",
    submitButton: "Soumettre le rapport",
    analyzingButton: "Analyse et création...",
    successTitle: "Incident créé avec succès !",
    createAnother: "Créer un autre incident",
    viewAll: "Voir tous les incidents",
    moreContext: "Donner plus de contexte",
    contextTips: "\n\nContexte supplémentaire:\n- Étapes pour reproduire:\n- Comportement attendu:\n- Comportement réel:\n- Environnement (Prod/Stage/Dev):",
    tipsTitle: "Conseils rapides",
    priorityTitle: "Niveaux de priorité",
    needHelpTitle: "Besoin d'aide ?",
    contactSupport: "Contacter le support",
    analysisGenerating: "Génération de suggestions...",
    analysisGeneratingMsg: "L'IA analyse les détails de votre incident.",
    analysisFailed: "L'analyse a échoué"
  },
  incidentDetail: {
    notFound: "Incident non trouvé",
    notFoundMsg: "L'incident que vous recherchez n'existe pas.",
    createdOn: "Créé le",
    reportedBy: "Signalé par",
    description: "Description",
    tags: "Tags",
    analysisTitle: "Analyse de l'incident",
    history: "Historique de l'incident",
    hideHistory: "Masquer l'historique",
    viewHistory: "Voir l'historique",
    selectAnalysis: "Analyse",
    latest: "Dernier"
  },
  status: {
    open: "Ouvert",
    in_progress: "En cours",
    resolved: "Résolu",
    closed: "Fermé"
  },
  priority: {
    low: "Basse",
    medium: "Moyenne",
    high: "Haute",
    critical: "Critique"
  },
  priorityLevels: {
    critical: "Système en panne",
    high: "Fonctionnalité majeure affectée",
    medium: "Problèmes mineurs",
    low: "Demandes d'amélioration"
  },
  tips: {
    0: "Inclure des messages d'erreur spécifiques",
    1: "Mentionner les systèmes affectés",
    2: "Décrire l'impact sur les utilisateurs",
    3: "Noter quand le problème a commencé"
  },
  company: {
    title: "Gestion des entreprises",
    createButton: "Créer une entreprise",
    listTitle: "Entreprises existantes",
    error: "Échec du chargement des entreprises.",
    noCompaniesTitle: "Aucune entreprise trouvée",
    noCompaniesMsg: "Aucune entreprise n'est enregistrée dans le système. Créez-en une pour commencer."
  }
};
